
  import {
    computed,
    defineComponent,
    onBeforeUnmount,
    onMounted,
    ref,
    watch
  } from 'vue'
  import DataTable from '@/components/DataTable/index.vue'
  import moment from 'moment'
  import LongText from '@/components/LongText/index.vue'
  import { Button } from '@up.law/uplaw-ui'
  import { CompanyModel, ContactAudit } from '@/services/api/models'
  import { useRoute } from 'vue-router'
  import {
    AuditGetType,
    AuditStatusType,
    AuditType,
    MAINACTIONS
  } from '@/types'
  import { useStore } from 'vuex'
  import { useI18n } from 'vue-i18n'
  import Filter from '@/views/Company/audit/filter.vue'
  import { TYPE } from 'vue-toastification'
  import EmptyState from '@/components/EmptyState/index.vue'

  export default defineComponent({
    components: { DataTable, LongText, Button, Filter, EmptyState },
    props: {},
    setup() {
      const isProcessed = ref(false)
      const store = useStore()
      const route = useRoute()
      const { t } = useI18n()
      const selectedRows = ref<string[]>([])
      const selectedStatus = ref('')
      const data = computed(() => store.getters['organizations/contactAudits'])
      const currentCompany = computed<CompanyModel>(
        () => store.getters['organizations/contextCompany']
      )
      const classes = ref<any>({
        PENDING: 'warning',
        IN_PROGRESS: 'primary',
        DONE: 'success',
        CANCELLED: 'error'
      })
      const pagination = ref(store.getters['organizations/auditPagination'])
      const columns = [
        {
          label: t(`datatable.column.date`),
          custom: true,
          field: 'createdAt'
        },
        { label: t(`datatable.column.motive`), custom: true, field: 'motive' },
        {
          label: t(`datatable.column.comment`),
          custom: true,
          field: 'comment'
        },
        {
          label: t(`datatable.column.status`),
          custom: true,
          field: 'processed'
        },
        { label: '', custom: true, field: 'actions', width: '3%' }
      ]

      const auditSelected = (row: string[]) => {
        selectedRows.value = row
      }
      const updateStatus = (status: AuditStatusType) => {
        updateAuditStatus(selectedRows.value, status, AuditGetType.CONTACT)
      }

      const updateAuditStatus = (
        ids: string[],
        status: AuditStatusType,
        type: AuditGetType
      ) => {
        store.dispatch('organizations/UPDATE_AUDIT_STATUS', {
          companyId: currentCompany.value.id,
          type,
          data: { auditsId: ids, status },
          onSuccess: () => {
            selectedRows.value = []
            store.dispatch('toolbox/displayToast', {
              type: TYPE.SUCCESS,
              context: t('audits.context'),
              message: t(`audits.editSuccess`)
            })
          },
          onError: () => {
            store.dispatch('toolbox/displayToast', {
              type: TYPE.ERROR,
              context: t('audits.context'),
              message: t(`audits.editError`)
            })
          }
        })
      }

      const openContactModal = (data: ContactAudit) => {
        store.dispatch('organizations/GET_COMPANY_CONTACT', {
          companyId: currentCompany.value.id,
          contactId: data.contact.id
        })
        store.dispatch('ui/toggleModal', {
          display: true,
          contentType: MAINACTIONS.CONTACT
        })
      }

      const markAsProcessed = (data: ContactAudit) => {
        const formData = {
          processed: true,
          comment: data.comment,
          motive: data.motive
        }
        store.dispatch('organizations/UPDATE_AUDIT', {
          companyId: currentCompany.value.id,
          type: AuditType.CONTACT,
          typeDataId: data.contact.id,
          auditId: data.id,
          formData,
          onSuccess: (audit: ContactAudit) => {
            console.log()
          },
          onError: () => {
            console.log('ERROR CREATE_AUDIT')
          }
        })
      }

      const onPageChange = (page: number) => {
        getAudits(page)
      }

      const getAudits = (page = 1) => {
        const filter: any = {}
        if (isProcessed.value) filter['isProcessed'] = isProcessed.value
        else delete filter['isProcessed']
        store.commit('organizations/SET_AUDIT_PAGINATION', page)
        store.dispatch('organizations/GET_CONTACT_AUDITS', {
          companyId: route.params.id,
          filter: {},
          onSuccess: (list: any) => {
            pagination.value = {
              total: list.metadata.count,
              currentPage: list.metadata.currentPage,
              lastPage: list.metadata.lastPage,
              limit: 10
            }
          }
        })
      }

      onMounted(() => {
        getAudits()
      })

      watch(isProcessed, () => {
        getAudits()
      })

      return {
        columns,
        moment,
        data,
        pagination,
        selectedStatus,
        classes,
        updateStatus,
        auditSelected,
        selectedRows,
        openContactModal,
        onPageChange,
        markAsProcessed
      }
    }
  })
